import styled from 'styled-components'
import {
  anatomyV2ContentWrapperCss,
  anatomyV2RootCss,
} from '~/pages/anatomyV2/libs/pageLayoutStyles'
import { Button } from '~/shared/components/Button'
import { COLORS } from '~/shared/constants/uiConstants'

export const AnatomyV2SocialProofStyles = {
  Root: styled.div`
    ${anatomyV2RootCss}
    overflow: hidden;
  `,

  ContentWrapper: styled.div`
    ${anatomyV2ContentWrapperCss}
    min-height: 0;
  `,

  ScrollContent: styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 16px;
  `,

  Title: styled.h1`
    font-size: 26px;
    font-weight: 800;
    line-height: 1.2;
    text-align: center;
    color: ${COLORS.BLACK};
    margin: 24px 0 12px;
  `,

  Quote: styled.p`
    color: rgba(0, 0, 0, 0.8);
    font-size: 14px;
    font-style: italic;
    font-weight: 700;
    line-height: 1.4;
    text-align: center;
    margin-bottom: 4px;
  `,

  Author: styled.p`
    color: rgba(0, 0, 0, 0.8);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 1.2;
    text-align: center;
  `,

  MapImage: styled.img`
    width: 100%;
    object-fit: contain;
    margin: 16px 0;
  `,

  FeaturedLabel: styled.p`
    color: #17202a;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    margin-bottom: 16px;
  `,

  PressLogosImage: styled.img`
    display: block;
    width: 100%;
    max-width: 230px;
    object-fit: contain;
    margin: 0 auto 24px;
    border-bottom: none;
  `,

  ButtonWrapper: styled.div`
    width: 100%;
    padding: 16px;
  `,

  StyledButton: styled(Button)`
    width: 100%;
  `,
}
